<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-center">
    <div class="lg:col-span-2 flex items-center" v-if="!edit_contractor">
      <div class="text-xl font-bold text-text leading-tight ">{{ $t('formTitle') }}</div>
    </div>
    <BaseInput v-model.trim="$v.title.$model"
               :label="$t('nameLabel')"
               :class="{'--error':$v.title.$error }">
      <template v-slot:errors="">
        <div class="error" v-if="!$v.title.required">{{ $t('errors.required') }}</div>
        <div class="error" v-else-if="!$v.title.noSpecSymbols">{{ $t('errors.noSpecSymbols') }}</div>
      </template>
    </BaseInput>
    <BaseSelect
        v-model="type"
        :options="type_list"
        label="name"
        :select-label="$t('typeLabel')"
        track-by="id"
        :searchable="false"
        :show-labels="false"
        :allow-empty="false"/>

    <div v-if="!edit_contractor" class="lg:col-span-2 grid grid-cols-2 items-center col-gap-12">
      <BaseButton theme="red"
                  class="w-78 lg:w-91 mr-8"
                  :loading="submitted"
                  @click="add">
        {{ $t('createLabel') }}
      </BaseButton>
    </div>
    <div v-else class="lg:col-span-2 flex flex-wrap items-center">
      <BaseButton @click="save"
                  class="w-78 lg:w-91 mr-8"
                  theme="gray"
                  :loading="submitted">
        {{ $t('saveChanges') }}
      </BaseButton>
      <BaseButton @click="$emit('cancelEdit')"
                  :loading="submitted"
                  class="w-50 lg:w-68 mr-20"
                  theme="white">
        {{ $t('cancel') }}
      </BaseButton>
      <ArchiveBtn class="ml-auto"
                  @confirm="archive"
                  :submitted="submitted">
        <template v-slot:text>
          {{ $t('deleteLabel') }}
        </template>
      </ArchiveBtn>
    </div>
  </div>
</template>

<script>
import {helpers, required} from 'vuelidate/lib/validators'
import {mapActions, mapGetters, mapState} from "vuex";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import ArchiveBtn from "@/components/UI/ArchiveBtn";

const noSpecSymbols = helpers.regex('noSpecSymbols', /^[^*|\/":<>[\]{}`\\()';@&!$]+$/)

export default {
  name: "ContractorsSettingsForm",
  components: {
    ArchiveBtn,
    BaseButton,
    BaseSelect,
    BaseInput
  },
  props: {
    edit_contractor: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitted: false,
      title: '',
      type: null,
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapGetters('cabinet/constants', ['getConstantList']),
    type_list() {
      return this.getConstantList('contractor')
    }
  },
  validations: {
    title: {
      required,
      noSpecSymbols
    }
  },
  methods: {
    ...mapActions('space/contractors', ['createContractor', 'getContractors', 'updateContractor', 'archiveContractor']),
    clearFields() {
      this.title = '';
      this.type = this.type_list[2];
      this.$v.$reset();
    },
    setFields(item) {
      this.title = item.title;
      this.type = this.type_list.filter(i => item.type === i.id)[0]
    },
    add() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        let data = {
          space_id: this.current_space.data.id,
          title: this.title,
          type: this.type.id,
        }
        this.createContractor(data).then((res) => {
          if (res.body.success) {
            this.getContractors();
            this.clearFields();
            this.$toasted.success('Контрагент добавлен')
            this.submitted = false;
          } else {
            console.log(res);
          }
        }).finally(() => {
          this.submitted = false;
        })
      } else {
        this.$toasted.error('Проверьте поля')
      }
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        let data = {
          id: this.edit_contractor.id,
          title: this.title,
          type: this.type.id
        }
        this.updateContractor(data).then((res) => {
          if (res.body.success) {
            this.$emit('cancelEdit');
            this.getContractors();
            this.$toasted.success('Контрагент изменен')
            this.submitted = false;
          } else {
            alert(res);
          }
        }).finally(() => {
          this.submitted = false;
        })
      } else {
        this.$toasted.error('Проверьте поля')
      }
    },
    archive() {
      this.submitted = true;
      this.archiveContractor(this.edit_contractor.id).then(res => {
        if (res.body.success) {
          this.$emit('cancelEdit');
          this.getContractors();
          this.$toasted.info('Контрагент удален')
        } else {
          console.log(res)
        }
      }).finally(() => {
        this.submitted = false;
      })
    }
  },
  created() {
    this.type = this.type_list[2]
  },
  watch: {
    edit_contractor: {
      immediate: true,
      handler(newVal) {
        if (!!newVal) {
          this.setFields(newVal);
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Add contractor',
        nameLabel: 'Contractor\'s name',
        typeLabel: 'Contractor\'s type',
        createLabel: 'Create contractor',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        deleteLabel: 'Delete contractor'
      },
      ru: {
        formTitle: 'Добавление контрагента',
        nameLabel: 'Название контрагента',
        typeLabel: 'Тип контрагента',
        createLabel: 'Добавить контрагента',
        saveChanges: 'Сохранить изменения',
        cancel: 'Отмена',
        deleteLabel: 'Удалить контрагента'
      }
    }
  }
}
</script>
